import {
  parseAnalyticsBrowserConfig,
  initAnalyticsBrowser,
  type AnalyticsClient,
} from '@tov-plus/analytics/ga4/browser';

import { dashboardEnv } from '../config/env';

let client: AnalyticsClient | null = null;

function resolveDashboardAnalyticsLinkerDomains(): string[] {
  const domains = new Set<string>();

  for (const url of [
    dashboardEnv.signInUrl,
    dashboardEnv.signUpUrl,
    dashboardEnv.signOutUrl,
  ]) {
    if (!url) continue;

    try {
      domains.add(new URL(url).hostname);
    } catch {
      // Ignore malformed optional URLs; config validation handles required URLs.
    }
  }

  return [...domains];
}

export function initDashboardAnalytics(): AnalyticsClient {
  const config = {
    ...parseAnalyticsBrowserConfig(
      {
        measurementId: import.meta.env['VITE_GA4_MEASUREMENT_ID'] as
          | string
          | undefined,
        enabled: import.meta.env['VITE_GA4_ENABLED'] as string | undefined,
        debugMode: import.meta.env['VITE_GA4_DEBUG_MODE'] as string | undefined,
      },
      'dashboard',
    ),
    linkerDomains: resolveDashboardAnalyticsLinkerDomains(),
  };

  client = initAnalyticsBrowser(config);
  return client;
}

export function getDashboardAnalytics(): AnalyticsClient | null {
  return client;
}
